import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createSavedFilter, SavedFilterCreateData, SavedFiltersV2Response } from "PFCore/services/filters";
import { MutationOptions } from "PFTypes/request_options";
import { PageTarget, SavedFilter } from "PFTypes/saved_filters";

import { savedFiltersKeys } from "./query_keys";

export type CreateSavedFiltersMutationData = Omit<SavedFilterCreateData, "target">;

export const useSavedFiltersCreate = (
  target: PageTarget,
  { onSuccess, ...queryParams }: MutationOptions<CreateSavedFiltersMutationData, SavedFilter> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: savedFiltersKeys.creation(),
    mutationFn: (payload: CreateSavedFiltersMutationData) => createSavedFilter({ target, ...payload }),
    onSuccess: (...args) => {
      const newSavedFilter = args[0];
      queryClient.setQueryData(
        savedFiltersKeys.target(target),
        (savedFilters: SavedFiltersV2Response | undefined) => [...(savedFilters ?? []), newSavedFilter]
      );
      onSuccess?.(...args);
    },
    ...queryParams
  });
};
